export default __webpack_public_path__ + "static/media/campus3.44ff13bf.jfif";